import { BaseBlock } from "./BaseBlock";

export class TitleBlock
    extends BaseBlock {

    private readonly title: string;

    private root!: HTMLElement;

    constructor(
        title: string
    ) {

        super();

        this.title = title;

    }

    public override mount(): void {

        this.root =
            this.buildRoot();

    }

    public override update(): void {

        const newRoot =
            this.buildRoot();

        this.root.replaceWith(
            newRoot
        );

        this.root =
            newRoot;

    }

    public getRoot(): HTMLElement {

        return this.root;

    }

    // =====================================================

    private buildRoot(): HTMLElement {

        const wrapper =
            document.createElement("div");

        wrapper.className =
            "screen-title-block";

        const title =
            document.createElement("h2");

        title.textContent =
            this.title;

        wrapper.appendChild(
            title
        );

        return wrapper;

    }

}